import { Dispatch, SetStateAction } from "react";
import { VersionState } from "../../proto/api_pb";
import {
  FolderUploadInfo,
  UploadCardStatusInfo,
  UploadedFileInfo,
} from "../../components/FileUploadStatusCard/types";
import { Inbox, Session } from "talkjs/all";

export interface TracksPageProps {
  setUploadingFilesDetailsList: Dispatch<SetStateAction<UploadedFileInfo[]>>;
  setIsUploading: Dispatch<SetStateAction<boolean>>;
  setUploadingCardsStatusList: Dispatch<SetStateAction<UploadCardStatusInfo[]>>;
  session: Session | undefined;
  setInbox: Dispatch<SetStateAction<Inbox | undefined>>;
  setIsUploadProcessing: Dispatch<SetStateAction<boolean>>;
  openFoldersList?: OpenFoldersListType[]
  setOpenFoldersList?: Dispatch<SetStateAction<OpenFoldersListType[]>>;
  setFolderUploadInfo: Dispatch<SetStateAction<FolderUploadInfo | undefined>>
}

export const versionStateForFilter: Record<number, string> = {
  [VersionState.VERSION_STATE_UNSPECIFIED]: "VERSION_STATE_UNSPECIFIED",
  [VersionState.VERSION_STATE_READY_FOR_RECORDING]:
    "VERSION_STATE_READY_FOR_RECORDING",
  [VersionState.VERSION_STATE_READY_FOR_MIXING]:
    "VERSION_STATE_READY_FOR_MIXING",
  [VersionState.VERSION_STATE_READY_FOR_MASTERING]:
    "VERSION_STATE_READY_FOR_MASTERING",
  [VersionState.VERSION_STATE_READY_FOR_PUBLISHING]:
    "VERSION_STATE_READY_FOR_PUBLISHING",
  [VersionState.VERSION_STATE_COMPLETED]:
    "VERSION_STATE_COMPLETED",
  [VersionState.VERSION_STATE_PRE_PRODUCTION]:
    "VERSION_STATE_PRE_PRODUCTION",
};

export const filterAndSort = {
  userIds: [],
  sortBy: "Last modified",
  isAscending: false,
  genreList: [],
  artistList: [],
  collaboratorsList: [],
  TrackPrivacy: "All",
  page: 0,
  limit: 100,
  bpmStartValue: 0,
  bpmEndValue: 500,
  status: "",
  isCompletedTracks: false
};

export interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export interface OpenFoldersListType {
  id: string;
  name: string
}